import FilterComponent from "./FilterComponent";

export default FilterComponent;
